export default {
  message: {
    hello: 'Olá mundo!'
  },
  createAccount: {
    signinTitle: 'Crie sua conta no Moip, é grátis!'
  }
}



// WEBPACK FOOTER //
// ./src/language/pt-br.js